// extracted by mini-css-extract-plugin
export var container = "titlePreview-module--container--CnVR5";
export var header = "titlePreview-module--header--YVyu-";
export var subTitle = "titlePreview-module--subTitle--WQIsJ";
export var callToAction = "titlePreview-module--callToAction--1s0Y4";
export var screenshot = "titlePreview-module--screenshot--6RrKC";
export var title = "titlePreview-module--title--fOH7n";